module.exports = __webpack_public_path__ + "static/media/DownloadCenter.962d9e37.svg";